import { HeartPulse, MapPin, Moon, Utensils, Wrench } from "lucide-react";

import { resolvedSurvivorActivity, survivorActivityLabel } from "../lib/scheduling";
import type { GameState, Survivor } from "../types";
import { SurvivorPortrait } from "./SurvivorPortrait";

function assignmentLabel(survivor: Survivor, state: GameState): string {
  return survivorActivityLabel(state, survivor);
}

export function SurvivorStrip({ state, selected, onSelect }: { state: GameState; selected: string | null; onSelect: (id: string) => void }) {
  const visibleSurvivors = state.survivors.slice(0, 8);
  const hiddenCount = Math.max(0, state.survivors.length - visibleSurvivors.length);
  return (
    <div className="survivor-strip" aria-label="Community survivors">
      <div className="strip-label"><span>{state.survivors.filter((item) => item.alive).length}</span><small>souls<br />remaining</small></div>
      <div className="survivor-cards">
        {visibleSurvivors.map((survivor) => {
          const activity = resolvedSurvivorActivity(survivor).kind;
          const statusIcon = activity === "dead" || activity === "treatment"
            ? HeartPulse
            : activity === "away"
              ? MapPin
              : activity === "rest" || activity === "idle"
                ? Moon
                : Wrench;
          const Icon = statusIcon;
          return (
            <button key={survivor.id} aria-pressed={selected === survivor.id} className={`${selected === survivor.id ? "selected" : ""} ${!survivor.alive ? "dead" : ""}`} onClick={() => onSelect(survivor.id)}>
              <SurvivorPortrait survivor={survivor} className="large" detail="thumb" />
              <span className="survivor-card-copy"><strong>{survivor.name}</strong><small><Icon size={11} />{assignmentLabel(survivor, state)}</small></span>
              <span className="mini-needs"><i title={`Health ${survivor.health}%`}><HeartPulse size={10} /><b style={{ width: `${survivor.health}%` }} /></i><i title={`Hunger ${survivor.hunger}%`}><Utensils size={10} /><b style={{ width: `${100 - survivor.hunger}%` }} /></i></span>
            </button>
          );
        })}
        {hiddenCount > 0 && <button className="survivor-overflow-card" onClick={() => onSelect(state.survivors[8]!.id)}><strong>+{hiddenCount}</strong><small>Open full roster</small></button>}
      </div>
    </div>
  );
}
